import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface ErrorSliceState {
    success:boolean
    error: string | null;
    errors: {
        [key: string]: string[];
    };
}

const initialErrorState: ErrorSliceState = {
    success:false,
    error: null,
    errors: {},
};

const changePasswordErrorSlice = createSlice({
    name: "error",
    initialState: initialErrorState,
    reducers: {
        setChangePasswordError: (state, action: PayloadAction<{ success: boolean; error: string; errors: { [key: string]: string[] } }>) => {
            state.error = action.payload.error;
            state.errors = action.payload.errors;
            state.success = action.payload.success
        },
    },
    extraReducers: (builder) => {
        // Добавьте сюда необходимые extraReducers, связанные с обработкой ошибок, если это требуется.
    },
});

export const {setChangePasswordError} = changePasswordErrorSlice.actions;
export const {reducer: changePasswordErrorReducer} = changePasswordErrorSlice;